import React, { useState } from 'react';
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { Delete, Edit } from '@mui/icons-material';
import FuseLoading from '@fuse/core/FuseLoading';
import SimpleDialog from '@fuse/core/SimpleDialog';
import {
  useGetAllFinancingTypeQuery,
  useDeleteFinancingTypeMutation,
} from 'src/app/services/projectTagsTypesApi';
import FinancingTypeProjectsForm from './FinancingTypeProjectsForm';
import useMessage from 'src/app/hooks/useMessage';
import handleError from '@fuse/core/errorHandler';

const FinancingTypeProjects = () => {
  const { t, i18n } = useTranslation('translations');
  const [currentFinancingtype, setCurrentFinancingtype] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { data: financingType = [], refetch, isLoading } = useGetAllFinancingTypeQuery();
  const [deleteCategory] = useDeleteFinancingTypeMutation();
  const { showMessage } = useMessage();

  const showAddDialog = () => {
    setCurrentFinancingtype(null);
    setIsDialogOpen(true);
  };

  const showEditDialog = (item) => {
    setCurrentFinancingtype(item);
    setIsDialogOpen(true);
  };

  const handleDelete = (id) => {
    deleteCategory(id)
      .unwrap()
      .then(() => {
        showMessage({ message: t('SuccessfullyDeleted'), variant: 'success' });
      })
      .catch(handleError);
  };

  return (
    <div style={{ display: 'grid' }}>
      {isLoading ? (
        <FuseLoading />
      ) : (
        <TableContainer>
          <div className="h-[40px] flex flex-row justify-between items-center dark:bg-dark">
            <h2 className="ml-5">{t('FinancingTypeProjects')}</h2>
            <Button
              className="mx-8"
              size="small"
              variant="outlined"
              color="secondary"
              onClick={showAddDialog}
            >
              <FuseSvgIcon size={20}>react-outline:plus</FuseSvgIcon>
              <span className="mx-8">{t('Add')}</span>
            </Button>
          </div>
          <Table style={{ overflow: 'auto' }}>
            <TableBody className="overflow-y-auto">
              {financingType.map((item) => (
                <TableRow key={item.id} className="bg-white hover:bg-grey-200 dark:bg-dark">
                  <TableCell>{item.name}</TableCell>
                  <TableCell>
                    <div className="flex justify-end">
                      <IconButton
                        edge="end"
                        aria-label="edit"
                        className="mr-5"
                        color="info"
                        onClick={() => showEditDialog(item)}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        className="mr-5"
                        color="error"
                        onClick={() => handleDelete(item.id)}
                      >
                        <Delete />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <SimpleDialog
        title={currentFinancingtype ? t('Edit') : t('Add')}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      >
        <FinancingTypeProjectsForm
          tempCat={currentFinancingtype}
          onClose={() => setIsDialogOpen(false)}
          isEdit={!!currentFinancingtype}
        />
      </SimpleDialog>
    </div>
  );
};

export default FinancingTypeProjects;
